
export default {
    computed: {
        options () {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                {
                    text: this.$t("global.common.recent_month", {
                        defaultValue: "最近一月",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 30
                        );
                        return [start, end];
                    },
                },
                {
                    text: this.$t("global.common.latest_quarter", {
                        defaultValue: "最近一季度",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 90
                        );
                        return [start, end];
                    },
                },
              ],
            };
        },
        // 单据状态
        getBillStatus() {
            return [{
                label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),
                value: '0',
            },  {
                label: this.$t('global.common.finished', { defaultValue: '已完成' }),
                value: '70',
                theme: 'success'
            }, {
                label: this.$t('global.common.canceled', { defaultValue: '已取消' }),
                value: '90',
                theme: 'error'
            }]
        },
        // 换标上架计划列表页单据状态
        getBillStatus1() {
            return [
                {
                    label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),
                    value: 0,
                },
                {
                    label: this.$t('fbb.headlogistics.daishenhe', { defaultValue: '待审核' }),
                    value: 5,
                    theme: 'error'
                },
                {
                    label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                    value: 6,
                },
                {
                    label: this.$t('fbb.costmanage.processed',{defaultValue:'待处理'}),
                    value: 10,
                },
                {
                    label: this.$t('bi.work.task_status_processing',{defaultValue:'处理中'}),
                    value: 15,
                },
                {
                    label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    value: 70,
                },
                {
                    label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                    value: 90,
                },
            ]
        },
        // 换标上架单单据状态
        getBillStatus2() {
            return [
                {
                    label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),
                    value: '0',
                },
                {
                    label: this.$t('global.common.confirmed', { defaultValue: "已确认" }),
                    value: '70',
                    theme: 'success'
                },
                {
                    label: this.$t('global.common.canceled', { defaultValue: '已取消' }),
                    value: '90',
                }
            ]
        },
        // FBA调拨单据状态
        getBillStatus3() {
            return [
                {
                    label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),
                    value: 0,
                },
                {
                    label: this.$t('fbb.headlogistics.daishenhe', { defaultValue: '待审核' }),
                    value: 5,
                    theme: 'error'
                },
                {
                    label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                    value: 6,
                },
                {
                    label: this.$t('fbb.transfer.preparedgoods', { defaultValue: "待备货" }),
                    value: 9,
                },
                {
                    label: this.$t('fbb.costmanage.processed',{defaultValue:'待处理'}),
                    value: 10,
                },
                {
                    label: this.$t('bi.work.task_status_processing',{defaultValue:'处理中'}),
                    value: 15,
                },
                {
                    label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    value: 70,
                },
                {
                    label: this.$t('global.common.canceled', { defaultValue: '已取消' }),
                    value: 90,
                },
            ]
        },
        /**
         * 库存类型
         */
        getInventoryType() {
            return [
                { value: 0, label: this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }) },
                { value: 1, label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }) },
            ]
        },

        /**
         * 业务类型
         *
         */
        getType() {
            return [{
                label: this.$t('bi.work.task_category_other', { defaultValue: '其他' }),
                value: 0,
            },  {
                label: this.$t('fbb.inventory.stock_init', { defaultValue: '库存初始化' }),
                value: 1,
            }, {
                label: this.$t('fbb.misc.send_back', { defaultValue: '借出还回' }),
                value: 2,
            }, {
                label: this.$t('fbb.misc.gift_received', { defaultValue: '赠品接收' }),
                value: 3,
            }, {
                label: this.$t('fbb.misc.inventory_check', { defaultValue: '库存盘点' }),
                value: 4,
            }, {
                label: this.$t('fbb.misc.diff_adjust', { defaultValue: '库存差异调整' }),
                value: 5,
            }, {
                label: this.$t('fbb.misc.common_adjust', { defaultValue: '一般入库接收调整' }),
                value: 6,
            }, {
                label: this.$t('fbb.misc.remove_warehouse', { defaultValue: '移库' }),
                value: 7,
            }, {
                label: this.$t('fbb.misc.remove_other', { defaultValue: '跨仓移库' }),
                value: 10,
            }]
        },
        getOutType() {
            return [{
                label: this.$t('bi.work.task_category_other', { defaultValue: '其他' }),
                value: 0,
            },  {
                label: this.$t('fbb.misc.send', { defaultValue: '借出' }),
                value: 1,
            }, {
                label: this.$t('fbb.misc.inventory_check', { defaultValue: '库存盘点' }),
                value: 2,
            }, {
                label: this.$t('fbb.misc.diff_adjust', { defaultValue: '库存差异调整' }),
                value: 3,
            }, {
                label: this.$t('fbb.misc.common_adjust', { defaultValue: '一般入库接收调整' }),
                value: 4,
            }, {
                label: this.$t('fbb.misc.remove_warehouse', { defaultValue: '移库' }),
                value: 7,
            }, {
                label: this.$t('fbb.misc.remove_other', { defaultValue: '跨仓移库' }),
                value: 10,
            }]
        },
         /**
         * 来源类型
         */
        getSrcLabel() {
            return [
                { value: 0, label: this.$t('erp.channel.manual', { defaultValue: 'MANUAL' }) },
                { value: 5, label: this.$t('fbb.misc.adjustment', { defaultValue: 'ADJUSTMENT' }) },
            ]
        },
        getLogActions () {
            return {
                4: this.$t('fbb.inbound.common_tracking_to_boss', { defaultValue: 'tracking回写Boss' }),
                10: this.$t('fbb.inbound.common_push_attachment', { defaultValue: '推送附件' }),
                13: this.$t('fbb.inbound.common_stock_rewrite', { defaultValue: '库存流水回写' }),
                20: '附件上传',
                21: '附件删除',
                24: '买面单',
                90: this.$t('fbb.inbound.common_lose_efficacy', { defaultValue: '失效' }),
                96: this.$t('fbb.inbound.common_fba_data_import', { defaultValue: 'FBA箱数据导入' }),
                100: this.$t('global.common.create', { defaultValue: '创建' }),
                150: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                200: this.$t('fbb.inbound.common_update', { defaultValue: '更新' }),
                210: this.$t('global.common.operation_submit', { defaultValue: '提交' }),
                215: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
                220: this.$t('fbb.inbound.common_shipping', { defaultValue: '发运' }),
                230: this.$t('fbb.inbound.common_save_and_commit', { defaultValue: '保存并提交' }),
                240: this.$t('fbb.inbound.common_widthdraw_reply', { defaultValue: '撤回申请' }),
                250: this.$t('global.common.save', { defaultValue: '保存' }),
                260: this.$t('global.common.edit', { defaultValue: '编辑' }),
                290: this.$t('fbb.inbound.common_unloading', { defaultValue: '卸货' }),
                300: this.$t('global.common.delete', { defaultValue: '删除' }),
                400: this.$t('global.common.cancel', { defaultValue: '取消' }),
                500: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                560: this.$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' }),
                600: this.$t('fbb.inbound.common_audit_rejection', { defaultValue: '审核拒绝' }),
                610: this.$t('fbb.inbound.common_boss_handle', { defaultValue: 'BOSS处理' }),
                620: this.$t('fbb.inbound.common_file_export', { defaultValue: '文件导出' }),
                700: this.$t('fbb.inbound.audit', { defaultValue: '审核' }),
                710: this.$t('fbb.inbound.common_outbound', { defaultValue: '已出库' }),
                720: this.$t('global.common.confirmed', { defaultValue: '已确认' }),
                730: this.$t('erp.aftersales.buyfaceorder', { defaultValue: "购买面单" }),
                740: '取消面单',
                800: this.$t('global.common.finish', { defaultValue: '完成' }),
                810: this.$t('fbb.transfer.warehouse_in_complete', { defaultValue: '入库完成' }),
                820: this.$t('fbb.transfer.warehouse_out_complete', { defaultValue: '出库完成' }),
                830: this.$t('fbb.inbound.rawcrates_standard', { defaultValue: '生成箱标' }),
                840: this.$t('fbb.inbound.common_operate_change_warehouse', { defaultValue: '换仓操作' }),
                910: this.$t('fbb.headlogistics.tianjiabeizhu', { defaultValue: '添加备注' }),
                930: this.$t('fbb.inbound.common_push_warehouse', { defaultValue: '推送仓库' }),
                931: "推送物流",
                935: "取消推送仓库",
                940: "执行单推送仓库",
                945: "完成推送仓库",
                950: "销毁推送仓库",
                1010: this.$t('fbb.inbound.common_notice_boss', { defaultValue: '调拨入库执行单回传boss' }),
                1020: this.$t('fbb.inbound.click_packing', { defaultValue: '一键装箱' }),
                1030: this.$t('fbb.inbound.confirm_delivery', { defaultValue: '确认发货' }),
                1031: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                1040: this.$t('fbb.inbound.common_purchase_notice', { defaultValue: '采购入库执行单回传' }),
                1045: "销毁推送仓库",
                1046: this.$t('fbb.inbound.common_confirm_reach_warehouse', { defaultValue: '确认到仓' }),
                1050: this.$t('fbb.inbound.common_confirm_push_boss', { defaultValue: '发运确认推送boss' }),
                1060: this.$t('fbb.inbound.common_audit_push_boss', { defaultValue: '审核通过推送boss' }),
                1070: this.$t('fbb.inbound.common_refuse_push_boss', { defaultValue: '审核退回推送boss' }),
                1047: this.$t('fbb.inbound.port_confirm', { defaultValue: '到港确认' }),
                1073:this.$t('fbb.inbound.common_warehouse_rewrite', { defaultValue: '仓库回写' }),
                1090:this.$t('fbb.headlogistics.shangchuanfapiao', { defaultValue: '上传发票' })
            }
        },
        getManageBillType(){
            return [
                {
                    label: this.$t('fbb.alloment.alloment_out', { defaultValue: "调拨出库" }),
                    value: 1
                },
                {
                    label: this.$t('fbb.alloment.alloment_in', { defaultValue: "调拨入库" }),
                    value: 2
                }
            ]
        },
        //FBA调拨单据类型
        getFbaBillType() {
            return [
                {
                    label: this.$t('fbb.fbatransfer.amazonout', { defaultValue: "亚马逊移出" }),
                    value: 0
                },
                {
                    label: this.$t('fbb.fbatransfer.amazonin', { defaultValue: "移入亚马逊" }),
                    value: 1
                },
                {
                    label: this.$t('fbb.transfer.ordinary_transfer_between', {defaultValue: '仓仓调拨'}),
                    value: 2
                },
                {
                    label: this.$t('fbb.transfer.ordinary_transfer_out', { defaultValue: "调拨出库" }),
                    value: 3
                }]
        },
        //单据类型
        getBillType() {
            return [
                {
                    label: this.$t('fbb.alloment.alloment_warehouse_to_warehouse', { defaultValue: "调拨(仓-仓)" }),
                    value: 0
                },
                {
                    label: this.$t('fbb.alloment.alloment_out', { defaultValue: "调拨出库" }),
                    value: 1
                },
                {
                    label: this.$t('fbb.alloment.alloment_in', { defaultValue: "调拨入库" }),
                    value: 2
                },
                {
                    label: this.$t('fbb.alloment.onsite_alloment', { defaultValue: "Onsite调拨" }),
                    value: 4
                }
            ]
        },
        //FBA调拨单据状态
        getFbaBillStatusSelect() {
            return [
                {
                    label: this.$t('fbb.alloment.draft', { defaultValue: "草稿" }),
                    value: 0
                },
                {
                    label: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                    value: 5,
                    theme: 'error'
                },
                {
                    label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                    value: 3,
                },
                {
                    label: this.$t('fbb.alloment.auditing', { defaultValue: "审核中" }),
                    value: 6,
                },
                {
                    label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                    value: 7,
                },
                {
                    label: this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),
                    value: 8,
                },
                {
                    label: this.$t('fbb.transfer.preparedgoods', { defaultValue: "待备货" }),
                    value: 9,
                    theme: 'warning'
                },
                {
                    label: this.$t('fbb.alloment.wait_for_outbound', { defaultValue: "待出库" }),
                    value: 10,
                    theme: 'primary'
                },
                {
                    label: this.$t('fbb.alloment.outbounding', { defaultValue: "出库中" }),
                    value: 15,
                },
                {
                    label: this.$t('fbb.alloment.wait_for_inbound', { defaultValue: "待入库" }),
                    value: 20,
                    theme: 'primary'
                },
                {
                    label: this.$t('fbb.alloment.inbounding', { defaultValue: "入库中" }),
                    value: 25,
                },
                {
                    label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    value: 70,
                    theme: 'success'
                },
                {
                    label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                    value: 110,
                },
                {
                    label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                    value: 120,
                }
            ]
        },
        //FBA调拨异常类型
        getErrorSimpleType(){
            return [ {
                label: this.$t('fbb.inbound.error_push', { defaultValue: "推送异常" }),
                value: 1
            }, {
                label: this.$t('fbb.inbound.error_approve', { defaultValue: "审核异常" }),
                value: 3
            },  {
                label: this.$t('fbb.alloment.confirm_error', { defaultValue: "确认异常" }),
                value: 5
            },  {
                label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                value: 6
            }, {
                label: this.$t('fbb.inbound.error_attachment_push', { defaultValue: "附件推送异常" }),
                value: 8
            }, {
                label: this.$t('fbb.alloment.wms_back_fbb_error', { defaultValue: "wms回传fbb异常" }),
                value: 11
            },  {
                label: this.$t('fbb.alloment.dock_back_fbb_error', { defaultValue: "dock回传fbb异常" }),
                value: 14
            },  {
                label: this.$t('fbb.alloment.action_order_push_error', { defaultValue: "执行单推送异常" }),
                value: 18
            }, {
                label: this.$t('fbb.inbound.error_complete', { defaultValue: "完成异常" }),
                value: 19
            }, {
                label: this.$t('erp.b2c.errorcode_buylabelException', { defaultValue: "购买面单异常" }),
                value: 20
            }]
        },
    }
}
